import React from "react";
import { BannerColorTheme, BannerContentPosition } from "./Common";
import BannerContainer, { BannerContainerProps } from "./BannerContainer";
import BannerShares, { BannerSharesProps } from "./BannerShares";
import BannerStatisticsCards, { BannerStatisticsProps } from "./BannerStatisticsCards";

enum ContentTypes {
    BannerShares = "bannerShares",
    BannerStatistics = "bannerStatistics",
}

type ContentProps = {
    _type: ContentTypes;
    center: boolean;
    colorTheme: BannerColorTheme;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
};

export interface BannerFinancialInformationProps extends BannerContainerProps {
    content?: ContentProps[];
    contentPosition?: BannerContentPosition;
}

const BannerContent = ({center, _type, ...props}: ContentProps) => {
    let content: JSX.Element | null = null;

    switch (_type) {
        case ContentTypes.BannerShares:
            content = <BannerShares {...props as BannerSharesProps} />;
            break;
        case ContentTypes.BannerStatistics:
            content = <BannerStatisticsCards {...props as BannerStatisticsProps} />;
            break;
    }

    if (center) {
        return <div className="max-w-4xl mx-auto">{content}</div>;
    }
    else {
        return content;
    }
};

const BannerFinancialInformation = ({ content, contentPosition, ...props }: BannerFinancialInformationProps) => (
    <BannerContainer {...props} colorTheme={BannerColorTheme.Default}>
        <div 
            className={`flex flex-col mx-auto lg:justify-between lg:flex-row ${contentPosition === BannerContentPosition.Right ? "lg:flex-row-reverse" : ""}`}
            style={{maxWidth: "79rem"}}
        >
            {content?.map((item, index) => 
                <div key={index} className="mb-8 last:mb-0 lg:mb-0">
                    <BannerContent 
                        {...item}
                        colorTheme={BannerColorTheme.Default}
                        center={content.length === 1 && contentPosition === BannerContentPosition.Auto}
                    />
                </div>)}
        </div>
    </BannerContainer>
);

export default BannerFinancialInformation;
